import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig, )
  .catch(err => console.error(err));

/* Remova imports globais desnecessários de CSS
   Importe apenas o essencial no styles.css global */
